// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {permissionSetItem, permissionGetItem} from '../../actions/userActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/user/PermissionAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as areaList} from '../../containers/area/AreaListPage';


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.user.permissionGetItem,
        userValue: state.app.currentUser,
        areaList : state.area.areaList,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(edit(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const edit = (values) => {
    let id = values.user_id;

    return (dispatch, getState) => {
        var formData = {
            'state_access' : values.state_access,
            'permissions'  : values.permissions,
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('user/permissions/'+id, formData).then(editRes => {
            dispatch(permissionSetItem(editRes.data));
            if(editRes.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/user/list'}), 100)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('user/permissions/'+id).then(userInfo => {
            dispatch(permissionGetItem(userInfo.data));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
